import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format a Date as YYYY-MM-DD using LOCAL calendar getters — never .toISOString()
// on a user-picked Date, or a non-UTC browser will shift the stored date by a day
// (in Europe/Madrid: Oct 4 00:00 CEST → 2026-10-03T22:00:00Z → wrong "2026-10-03").
export function toIsoLocal(date) {
  if (!(date instanceof Date) || isNaN(date)) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
